// assets/scroll-restoration.js
(function () {
  // Use pathname + query so each page gets its own key
  const key = `scroll:${location.pathname}${location.search}`;

  // Disable automatic restoration so we can control it
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  // Save current scroll position before leaving
  const saveScroll = () => {
    try {
      sessionStorage.setItem(key, String(window.scrollY));
    } catch (e) {
      /* ignore quota errors */
    }
  };

  // Safari-friendly events to catch all exit cases
  window.addEventListener('pagehide', saveScroll);
  window.addEventListener('beforeunload', saveScroll);

  // Restore on pageshow (triggered by back/forward navigation)
  window.addEventListener('pageshow', (event) => {
    const saved = sessionStorage.getItem(key);
    if (saved !== null) {
      // Restore only if it's a back/forward nav or cached load
      if (event.persisted || performance.getEntriesByType('navigation')[0]?.type === 'back_forward') {
        window.scrollTo(0, parseInt(saved, 10));
      }
    }
  });
})();